import { Outlet } from 'react-router-dom';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { useGetCaregiverStatus } from 'hooks/use-get-caregiver-status.hook';
import { PageNotFound } from 'pages/errors/page-not-found/page-not-found.page';

export const NonCaregiverRoutes = () => {
  const { data: isCaregiver, isLoading } = useGetCaregiverStatus();

  if (isLoading) return <LoadingIndicator />;
  if (isCaregiver) return <PageNotFound />;

  return <Outlet />;
};
